import { apiGet } from '../support/helpers/ApiConnection.Helper';
import ReferralVisitStatusEntity from '../entities/pt/ReferralVisitStatus.Entity';

export default function getReferralVisitStatuses(abortSignal: AbortSignal): Promise<Array<ReferralVisitStatusEntity>> {
    return apiGet<Array<ReferralVisitStatusEntity>>('/referral-visit/statuses', abortSignal);
}
